<template>
  <div class="toutiao-targeting-wrapper">
    <ToutiaoTargetingForm ref="targetingFormRef" is-add> </ToutiaoTargetingForm>

    <div class="submit-btns">
      <el-button @click="onFormCancel">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="onFormSubmit">提交</el-button>
    </div>
  </div>
</template>

<script setup>
import ToutiaoTargetingForm from './components/toutiao/targeting-form.vue'
import { useRoute, useRouter } from 'vue-router/composables'
import { useTargetingFormSubmit, useTargetingFormEdit } from './hooks/useToutiaoTargeting.js'
import { getInitForm } from './components/toutiao/useToutiaoTargetingForm.js'
import { onMounted } from 'vue'

const route = useRoute()
const router = useRouter()

const { targetingFormRef, onFormSubmit, submitLoading, onFormCancel } = useTargetingFormSubmit(router, getInitForm)
const { initFormEdit } = useTargetingFormEdit(targetingFormRef)

// 进入编辑页面
onMounted(() => {
  const { targetingId, t } = route.query
  if (targetingId && t) {
    initFormEdit(targetingId, t)
  } else {
    targetingFormRef.value.setForm(getInitForm())
  }
})
</script>

<style lang="scss" scoped>
.c-select-item {
  width: 400px;
  background-color: #fff;
  border: solid 1px #dee4f5;
  .c-header {
    padding: 0 12px;
    height: 34px;
    color: #333;
    border-bottom: solid 1px #dee4f5;
    background-color: #fafbfe;

    .c-header-title,
    .c-header-clear {
      height: 34px;
      line-height: 34px;
      vertical-align: middle;
    }

    .c-header-clear {
      color: #598fe6;
      float: right;
      cursor: pointer;
    }
  }

  .c-selecter-content {
    padding: 8px;
    .c-version-item {
      display: block;
      height: 34px;
      line-height: 34px;
      margin-left: 12px;
    }
  }
}
.toutiao-targeting-wrapper {
  height: calc(100% - 40px);
  overflow: hidden;
  overflow-y: auto;
  position: relative;

  padding: 80px 0;
  .el-form {
    width: 1420px;
    margin: 0 auto;

    .inventory_types {
      .check-all {
        margin-right: 30px;
      }
      display: flex;
    }
  }
}

.submit-btns {
  padding: 15px;
  background-color: #fff;
  border: 1px solid #eaeaea;
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 #eff1fa;
  width: 100%;
  text-align: right;
  position: absolute;
  // bottom: 0;
}
</style>
